import script from "./translate-modal.vue?vue&type=script&lang=js"
export * from "./translate-modal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/translation/translate-modal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "417e7592"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('417e7592', __exports__)) {
    console.log('reload')
    api.reload('417e7592', __exports__)
  }
  
}


export default __exports__